<template>
  <div class="carousel-list">
    <div class="table-search">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <div>
          <el-form-item label="标题：">
            <el-input
              v-model="form.informationTitle"
              placeholder="请输入品牌名称"
              @input="handleInputChange"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">添加资讯</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="informationTitle" label="资讯标题" align="center"></el-table-column>
        <el-table-column label="上架状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.informationState">上架</span>
            <span v-else>下架</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="上架时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span
              class="shelves"
              v-if="!scope.row.informationState"
              @click="handleShelves(scope.row.id,1)"
            >上架</span>
            <span
              class="shelves"
              v-else
              @click="handleShelves(scope.row.id,0)"
            >下架</span>
            <span class="view" @click="handlePreview(scope.row)">预览</span>
            <span class="del" @click="handleDel(scope.row.id)">删除</span>
            <span class="editor" @click="handleEditor(scope.row.id)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <Preview
      :visible="previewVisible"
      :selectId="currentCellId"
      @close="handleClosePreview"
    />
  </div>
</template>
<script>
import { getInformationList, updateInformationUpAndDown, deleteInformation } from '@/api/carousel';
import Preview from '@/components/h5/carouselPage.vue';
import preview from '@/mixins/mobile';
import Pagination from '@/components/Pagination';

export default {
  mixins: [preview],
  data() {
    return {
      form: {
        informationTitle: '',
      },
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  components: {
    Preview,
    Pagination,
  },
  mounted() {
    this.getInformationList();
  },
  methods: {
    getInformationList() {
      this.loading = true;
      return getInformationList({
        informationTitle: this.form.informationTitle,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
          return false;
        }
        this.$message.error(res.message);
        return false;
      });
    },
    // 输入查询
    handleInputChange() {
      this.currentPage = 1;
      this.getInformationList();
    },
    // 添加咨询
    handleAdd() {
      this.$router.push({ name: 'CarouselAdd' });
    },
    // 上下架
    handleShelves(id) {
      updateInformationUpAndDown(id).then((res) => {
        if (res.success) {
          this.$message.success('操作成功');
          this.getInformationList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 删除
    handleDel(id) {
      deleteInformation(id).then((res) => {
        if (res.success) {
          this.$message.success('删除成功');
          this.getInformationList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 编辑
    handleEditor(id) {
      this.$router.push({
        name: 'CarouselEditor',
        query: {
          id,
        },
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getInformationList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getInformationList();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content space-between
.view, .shelves, .del, .editor
  color #1890ff
  cursor pointer
.view, .shelves, .del, .editor
  margin-right 20px
.memberImg
  width 150px
  height 100px
.wechatImg
  width 150px
  height 150px
.homepageSelect
  margin-left 30px
</style>
<style lang="stylus">
.wechatCode
  background rgba(0, 0, 0, 0)
  min-width 150px
  padding 0
  border none
  margin 0
</style>
